import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, OUTLINE_BTN, PageHeader } from "../components/account-ui.tsx";
import { OrderLines, OrderTotals } from "../components/legacy/OrderSummary.tsx";
import { OrderStatusBadge } from "../components/status.tsx";
import { LeftArrowIcon } from "../icons/index.tsx";
import { api, type Order } from "../lib/api.ts";
import { formatDate } from "../lib/legacy.ts";

export const Route = createFileRoute("/account/orders/$code")({ component: OrderDetail });

interface OrderItem {
  kind: string;
  description: string;
  quantity: number;
  unit_cents: number;
  total_cents: number;
}

function OrderDetail() {
  const { code } = Route.useParams();
  const { data } = useQuery({
    queryKey: ["order", code],
    queryFn: () => api.get<{ order: Order; items: OrderItem[] }>(`/orders/${code}`),
  });
  if (!data) return <div className="h-[100vh]" />;
  const { order, items } = data;

  return (
    <div>
      <PageHeader
        title={
          <span className="flex flex-wrap items-center gap-3">
            Order {order.code}
            <OrderStatusBadge status={order.status} />
          </span>
        }
        subtitle={`Placed ${formatDate(order.placed_at ?? order.created_at)}`}
        action={
          <Link to="/account/orders" className={OUTLINE_BTN}>
            <LeftArrowIcon className="h-4 w-4" />
            Purchase History
          </Link>
        }
      />
      <Card className="max-w-3xl">
        <OrderLines items={items} campaignId={order.campaign_id} />
        <OrderTotals order={order} />
      </Card>
    </div>
  );
}
